import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { User } from '../models';

const DEFAULT_USER: User = {
  id: '',
  email: '',
  full_name: '',
  roles: [],
};

@Injectable({
  providedIn: 'root',
})
export class UserStoreService {
  private readonly _user$ = new BehaviorSubject<User>(DEFAULT_USER);

  public user$ = this._user$.asObservable();

  public setUser(user: User): void {
    this._user$.next(user);
  }

  public patchUser(changes: Partial<User>): void {
    this._user$.next({ ...this._user$.value, ...changes });
  }

  public resetUser(): void {
    this._user$.next(DEFAULT_USER);
  }
}
